<div class="page-content" style="max-width: 750px;">
  <div class="row mb-2">
    <h2 class="col-sm-6"></h2>
    <div class="col-sm-6 text-end">
      <!-- <dx-button text="Close" type="default" (onClick)="cancel()"></dx-button> -->
      @if (mode == 'drafts') {
        <dx-button text="Send" type="default" (onClick)="send()" style="margin-right: 20px;"></dx-button>
      }
      <dx-button text="Cancel" type="danger" (onClick)="cancel()"></dx-button>
    </div>
  </div>
  @if (message) {
    <div>
      <dx-form [(formData)]="message" [showColonAfterLabel]="false">
        <dxi-item itemType="group">
          <!-- <dxi-item
          dataField="toGroupId"
          [label]="{ text: 'To' }"
          editorType="dxSelectBox"
                    [editorOptions]="{
                        dataSource: groups,
                        displayExpr: 'name',
                        valueExpr: 'id',
                        onSelectionChanged: groupSelectionChanged
                    }"
        ></dxi-item> -->
        @if (message) {
          <dxi-item [label]="{ text: 'To' }">
            <div *dxTemplate>
              <dx-select-box
                [(value)]="message.toGroupId"
                [items]="groups"
                valueExpr="id"
                displayExpr="name"
                (onSelectionChanged)="groupSelectionChanged($event)"
              ></dx-select-box>
            </div>
          </dxi-item>
        }
        <dxi-item>
          <div>Recipients: {{ totalRecipients }}</div>
        </dxi-item>
        <dxi-item dataField="defaultHeader" [disabled]="false"></dxi-item>
        <dxi-item dataField="body" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
        <dxi-item>
          <div>
            Remaining characters:
            {{ 160 - message?.defaultHeader?.length - message?.body?.length - message?.defaultFooter?.length }} / 160
          </div>
        </dxi-item>
        <dxi-item dataField="defaultFooter" [disabled]="false"></dxi-item>
      </dxi-item>
    </dx-form>
  </div>
}
</div>

<!-- <div style="margin-top: 50px;">{{message?.body}}</div> -->
